import { themeQuartz } from "ag-grid-enterprise";

/**
 * Theme setup for light and dark mode grids
 */
export const tortugaMagneticTheme = themeQuartz.withParams({
  wrapperBorder: false,
  wrapperBorderRadius: 0,

  // TODO: Row selection icons: determine a cleaner way to point to Magnetic images by URL since inline data URI is forbidden
  // images loaded over network require `BASE_URL`
  checkboxCheckedShapeImage: {
    url: __BASE_URL__ + "magnetic/icons/checkbox-checked.svg"
  },
  checkboxIndeterminateShapeImage: {
    url: __BASE_URL__ + "magnetic/icons/checkbox-indeterminate.svg"
  },
  checkboxCheckedShapeColor: "var(--base-bg-active)",

  backgroundColor: "var(--control-bg-default)",
  checkboxBorderWidth: 2,

  checkboxUncheckedBorderColor: "var(--control-border-default)",
  fontSize: "var(--base-font-size-p3)",
  iconSize: 20,
  headerTextColor: "var(--base-text-default)",
  headerBackgroundColor: "var(--control-bg-default)",

  // 20260708 - UX has asked to remove zebra striping. But styling actually helps with visual accessibility when scanning large, dense datasets
  // oddRowBackgroundColor: "color-mix(in srgb, var(--control-bg-medium-disabled), var(--control-bg-default) 85%)",

  selectedRowBackgroundColor:
    "color-mix(in srgb, var(--control-bg-weak-active) 100%, transparent 40%)",

  foregroundColor: "currentColor",
  cellHorizontalPadding: 6, // "compact" mode : helps with some longer labels
  headerFontWeight: 700,

  valueChangeValueHighlightBackgroundColor: "var(--interact-bg-weak-active)", // data updates

  rowDragIndicatorColor: "var(--control-border-active)", // light blue
  rowDragIndicatorWidth: 2,

  // formula to get a reasonable "compact" row height
  rowVerticalPaddingScale: 1.0,
  // Magnetic matched sizes
  rowHeight: 37,
  headerHeight: 37,
  listItemHeight: 37
});
